import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthGate } from "./app/AuthGate";
import { SyncedApp } from "./app/SyncedApp";
import "./styles.css";

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <AuthGate>
      <SyncedApp />
    </AuthGate>
  </StrictMode>,
);
